import React from 'react';
import { COLOR_MAP } from '../../constants/colorConstants';
import { getStrokeWidth } from '../../utils/cableLogic';

const normalizeColorForVisualization = (color) => {
  if (!color) return color;
  return color;
};

const isEarthWire = (color) => {
  const normalized = normalizeColorForVisualization(color);
  return normalized === 'GI/VE' || normalized === 'YE/GN';
};

const CableSVGLine = ({
  cable,
  x1, y1, x2, y2,
  isHovered = false,
  opacity = 1,
  className = '',
  useAWG = false,
  ...otherProps
}) => {
  const isGialloVerde = isEarthWire(cable.colore);
  const strokeWidth = getStrokeWidth(cable.sezione, isHovered, useAWG);

  if (isGialloVerde) {
    // Pattern giallo/verde per cavi di terra
    return (
      <>
        <line
          x1={x1} y1={y1} x2={x2} y2={y2}
          stroke={COLOR_MAP['GIALLO']}
          strokeWidth={strokeWidth}
          opacity={opacity}
          strokeDasharray="8 8"
          strokeDashoffset={0}
          className={className}
          {...otherProps}
        />
        <line
          x1={x1} y1={y1} x2={x2} y2={y2}
          stroke={COLOR_MAP['VERDE']}
          strokeWidth={strokeWidth}
          opacity={opacity}
          strokeDasharray="8 8"
          strokeDashoffset={8}
          className={className}
          {...otherProps}
        />
      </>
    );
  } else {
    // Linea singola per altri colori
    const solidColor = COLOR_MAP[normalizeColorForVisualization(cable.colore)] || '#808080';
    const isWhite = solidColor === '#FFFFFF';

    if (isWhite) {
      // Per cavi bianchi, aggiungi un bordo scuro per la visibilità
      return (
        <>
          {/* Bordo scuro per visibilità */}
          <line
            x1={x1} y1={y1} x2={x2} y2={y2}
            stroke="#666666"
            strokeWidth={strokeWidth + 1}
            opacity={opacity}
            className={`cable-path-border ${isHovered ? 'animated' : ''} ${className}`}
            {...otherProps}
          />
          {/* Linea bianca principale */}
          <line
            x1={x1} y1={y1} x2={x2} y2={y2}
            stroke={solidColor}
            strokeWidth={strokeWidth}
            opacity={opacity}
            className={`cable-path ${isHovered ? 'animated' : ''} ${className}`}
            {...otherProps}
          />
        </>
      );
    } else {
      // Linea normale per altri colori
      return (
        <line
          x1={x1} y1={y1} x2={x2} y2={y2}
          stroke={solidColor}
          strokeWidth={strokeWidth}
          opacity={opacity}
          className={`cable-path ${isHovered ? 'animated' : ''} ${className}`}
          {...otherProps}
        />
      );
    }
  }
};

export default CableSVGLine;

